import React from 'react';
import { useWphiData } from './hooks/useWphiData';
import RadarChart from './charts/RadarChart';

export default function WphiReport({assignmentId}) {
 const result = useWphiData(assignmentId);
 if (result.status === 'absent') return null;
 return <section className="wphi-section" aria-label="WPHI">
  <h2>Índice de Salud Integral de la Persona (WPHI)</h2>
  {result.status === 'loading' && <p role="status">Cargando WPHI…</p>}
  {result.status === 'error' && <p role="status">No se pudo cargar WPHI.</p>}
  {result.status === 'incomplete' && <p role="status">WPHI incompleto: se requieren nueve respuestas válidas para calcular el índice.</p>}
  {result.status === 'complete' && <>
   <div className="radar-chart-container" style={{width:'100%',maxWidth:440}}><RadarChart data={Object.fromEntries(result.axes.map(a=>[a.label,a.value]))} size={240} maxValue={5} formatTooltip={(label,value)=>`${label}: ${value} / 5 — ${['Mala','Regular','Buena','Muy buena','Excelente'][value-1]}`}/></div>
  </>}
 </section>;
}
